<template>
  <div class="my-contents">
    <div class="page-header">
      <h2>My Contents</h2>
    </div>

    <el-card class="contents-card">
      <el-table 
        v-loading="loading"
        :data="contents"
        style="width: 100%"
      >
        <el-table-column label="Content" min-width="300">
          <template slot-scope="scope">
            <div class="content-info">
              <img 
                v-if="scope.row.content_info?.cover_url" 
                :src="scope.row.content_info?.cover_url" 
                class="content-cover"
                alt="Content cover"
              />
              <div class="content-details">
                <span class="content-type" :class="scope.row.content_type">
                  {{ scope.row.content_type }}
                </span>
                <span class="content-title">{{ scope.row.content_info?.title }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Status" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="created_at" label="Received Date" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>

        <el-table-column label="Actions" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="viewContent(scope.row)"
            >
              View Content
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="empty-state" v-if="!loading && contents.length === 0">
        <i class="el-icon-document"></i>
        <p>No contents found</p>
        <el-button type="primary" @click="goToContents">Browse Contents</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { postRequest } from '@/api/eclub'
import { getUserId } from '@/utils/store'

export default {
  name: 'MyContents',
  data() {
    return {
      contents: [],
      loading: false
    }
  },
  created() {
    this.fetchContents()
  },
  methods: {
    async fetchContents() {
      this.loading = true
      try {
        const response = await postRequest('getStudentContentCopies', {
          student_id: getUserId()
        })
        
        if (response.data.code === 0) {
          this.contents = response.data.data
        }
      } catch (error) {
        console.error('Error fetching contents:', error)
        this.$message.error('Failed to load contents')
      } finally {
        this.loading = false
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return '-'
      return new Date(timestamp * 1000).toLocaleString()
    },
    getStatusType(status) {
      const types = {
        ACTIVE: 'success',
        EXPIRED: 'info',
        USED: 'warning'
      }
      return types[status] || 'info'
    },
    viewContent(content) {
      this.$router.push({
        name: 'Content Profile',
        query: { content_id: content.content_id }
      })
    },
    goToContents() {
      this.$router.push({ name: 'Find Contents' })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-contents {
  padding: 20px;

  .page-header {
    margin-bottom: 20px;

    h2 {
      margin: 0;
      color: #303133;
    }
  }

  .contents-card {
    .content-info {
      display: flex;
      align-items: center;
      gap: 12px;

      .content-cover {
        width: 40px;
        height: 56px;
        object-fit: cover;
        border-radius: 4px;
      }

      .content-details {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .content-type {
          display: inline-block;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 12px;
          text-transform: capitalize;

          &.collection {
            background-color: #e1f3d8;
            color: #67c23a;
          }
        }

        .content-title {
          color: #303133;
        }
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: 40px 0;
    color: #909399;

    i {
      font-size: 48px;
      margin-bottom: 16px;
    }

    p {
      margin: 0 0 20px;
      font-size: 16px;
    }
  }
}
</style> 